/* ==========================================================================
   Catalog Action - in-stock alternative lengths (same shade) + texture fallback
   On the theme's 'variant:changed' event (and on load):
     - if the current variant is OOS, show in-stock lengths that match it on
       every option except length;
     - if none, reveal the server-rendered same-texture / different-method
       fallback (snippets/catalog-texture-fallback.liquid), but only for the
       server-selected shade so no stale shade copy shows after a shade switch.
   Keyed by variant id; ignores ids not in this block's own map (prevents
   cross-product bleed from quick-buy drawers). Product template only.
   ========================================================================== */
(function () {
  'use strict';

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findVariant(arr, id) {
    for (var i = 0; i < arr.length; i++) {
      if (String(arr[i].id) === String(id)) return arr[i];
    }
    return null;
  }

  function renderChips(block, lengths) {
    var list = block.querySelector('[data-alt-lengths-list]');
    if (!list) return;
    var html = '';
    for (var i = 0; i < lengths.length; i++) {
      var label = esc(lengths[i].l);
      html +=
        '<li class="alt-lengths__item">' +
        '<a class="alt-lengths__chip" href="' + encodeURI(String(lengths[i].u || '')) +
        '" aria-label="' + label + ' - in stock">' + label + '</a></li>';
    }
    list.innerHTML = html;
  }

  function showLengths(block) {
    var l = block.querySelector('[data-alt-lengths-lengths]');
    var f = block.querySelector('[data-alt-fallback]');
    if (l) { l.removeAttribute('hidden'); l.style.display = ''; }
    if (f) f.setAttribute('hidden', '');
    block.removeAttribute('hidden');
  }

  function hideBlock(block) {
    block.setAttribute('hidden', '');
  }

  /* Reveal the server-rendered same-texture / different-method recommendations
     placed in [data-alt-fallback]. The content is shade-agnostic (in-stock
     alternatives of the same texture and category), so it is correct for every
     sold-out variant - show it whenever a shade has no in-stock lengths.
     The lengths wrap has no [hidden] CSS override and is display:flex, so hide
     it with an inline style (highest specificity) rather than the attribute. */
  function loadFallback(block) {
    var fallback = block.querySelector('[data-alt-fallback]');
    var lengthsWrap = block.querySelector('[data-alt-lengths-lengths]');
    if (!fallback) { hideBlock(block); return; }
    if (lengthsWrap) { lengthsWrap.setAttribute('hidden', ''); lengthsWrap.style.display = 'none'; }
    fallback.removeAttribute('hidden');
    block.removeAttribute('hidden');
  }

  function update(block, variantId) {
    var arr = parseJSON(block.querySelector('[data-alt-lengths-variants]'));
    if (!arr) return;
    var cur = findVariant(arr, variantId);
    if (!cur) return; // event belongs to a different product

    if (cur.a !== false) { hideBlock(block); return; }

    var lengths = [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].a === true && arr[i].k === cur.k) lengths.push({ l: arr[i].l, u: arr[i].u });
    }

    if (lengths.length) {
      renderChips(block, lengths);
      showLengths(block);
    } else {
      loadFallback(block);
    }
  }

  function handleVariantChange(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || variant.id == null) return;
    var blocks = document.querySelectorAll('[data-alt-lengths]');
    for (var i = 0; i < blocks.length; i++) update(blocks[i], variant.id);
  }

  function init() {
    var blocks = document.querySelectorAll('[data-alt-lengths]');
    if (!blocks.length) return;

    // Initial state for the server-selected variant (covers OOS landing pages).
    for (var i = 0; i < blocks.length; i++) {
      var initId = blocks[i].getAttribute('data-initial-id');
      if (initId) update(blocks[i], initId);
    }

    document.addEventListener('variant:changed', handleVariantChange);
    var containers = document.querySelectorAll('[data-preorder-form]');
    for (var j = 0; j < containers.length; j++) {
      containers[j].addEventListener('variant:changed', handleVariantChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();